export default {
    body: 400,
    heading: 600,
    bold: 700,
  }